/**
 * A date filter that respects the user's preferred date format.
 *
 * @type {ngFilter}
 */
function tmrDate($filter, UserStorage) {
  'ngInject'
  // loggedUser is always resolved in a filter, since we use it in controllers and templates.
  return (date, timezone) => {
    let loggedUser = UserStorage.getUserSync()
    return $filter('date').call(
      this,
      date,
      loggedUser.data && loggedUser.data.dateFormat
        ? loggedUser.data.dateFormat
        : 'short',
      timezone
    )
  }
}

export const filter = ['tmrDate', tmrDate]
